import {
  CompositeView,
  GridView,
  SimpleView,
} from '@digital/ui';
import React from 'react';

import ConfiguracaoQaqc from './ConfiguracaoQaqc';
import ConfiguracaoPreSuprimentos from './ConfiguracaoPreSuprimentos';
import ConfiguracaoSas from './ConfiguracaoSas';
import ConfiguracaoSubcontratacao from './ConfiguracaoSubcontratacao';
import ConfiguracaoFaturamentoDireto from './ConfiguracaoFaturamentoDireto';

const Configuracao = () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <ConfiguracaoQaqc />
          <ConfiguracaoPreSuprimentos />
          <ConfiguracaoSas />
          <ConfiguracaoSubcontratacao />
          <ConfiguracaoFaturamentoDireto />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default Configuracao;
